import { Chart, registerables } from "chart.js";
import { enUS } from "date-fns/locale";
import 'chartjs-adapter-date-fns';
import zoomPlugin from 'chartjs-plugin-zoom';


export class ChartJsSwitchGraph {

    graph: Chart

    constructor () {

    }

    draw(data){
        Chart.register(zoomPlugin);
        Chart.register(...registerables);
        
        let dataArray = [];

        for(let i in data){
            dataArray.push(
                {
                    x: data[i].timestamp,
                    y: data[i].value
                }
            )
        }
        this.graph = new Chart("graph", {
            type: 'line',
            data: {
                datasets: [{
                    label: "Switch Usage",
                    data: dataArray,
                    borderWidth: 1,
                    pointRadius: 0,
                    borderColor: '#0E8E75',
                    backgroundColor: '#0E8E75',
                    stepped: 'after'
                }]
            },
            options: {
                scales: {
                    x: {
                        type: 'time',
                        adapters: {
                            date: {
                                locale: enUS
                            },
                        
                        },
                        time: {
                            unit: 'day',
                        }
                    },
                    y: {
                        type: 'linear',
                        max: 1,
                        min: 0,
                        ticks: {
                            autoSkip: true,
                            stepSize: 1,
                            callback: (value, index, values) => {
                                
                                return value === 0 ? "Off" : "On";
                            }
                        }
                    }
                },
                maintainAspectRatio: false,
                plugins: {
                    
                    tooltip: {
                        callbacks: {
                            label: (point) => {
                                let value = point.parsed.y;
                                return `Switch Status: ${value === 0 ? "Off" : "On"}`;
                            }
                        }
                    },
                    zoom: {
                        limits: {
                            
                        },
                        zoom: {
                          drag: {
                            enabled: true
                            
                          },
                          mode: 'x',
                         
                        }
                      }
                   
                }
                
                
            },
        });
    }



}